import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Company } from '../../types/company.types';
import { useAppQuery } from '../use-app-query.hook';
import { useLocale } from '../use-locale.hook';

type FetchCompany = {
  companyId: string;
  enabled?: boolean;
};

export const useCompany = ({ companyId, enabled }: FetchCompany) => {
  const queryClient = useQueryClient();
  const { locale } = useLocale();
  const { data: company, isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_COMPANY, companyId],
    queryFn: () =>
      ApiService.get<Company>(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId] },
        { locale },
      ),
    enabled: !!companyId && enabled,
  });
  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_COMPANY] });
  }, [queryClient]);

  return {
    isLoading,
    invalidateQuery,
    company,
  };
};
